import { render, staticRenderFns } from "./GetMessagesStatisticsNumbers.vue?vue&type=template&id=06a2f27c&"
import script from "./GetMessagesStatisticsNumbers.vue?vue&type=script&lang=js&"
export * from "./GetMessagesStatisticsNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports